import { useEffect, useState } from "react";
import { motion, animate } from "framer-motion";
import { QrCode, Tv, FileText, Receipt, Globe, Monitor, Store, Link2 } from "lucide-react";
import api from "@/lib/api";

const ROW_TRANSITION = { type: "spring", stiffness: 200, damping: 25 };
const BAR_INITIAL = { width: 0 };
const BAR_TRANSITION = { duration: 1.4, ease: "easeOut" };

const META = {
  totem: ["QR totem", Monitor, "#F59E0B"], tv: ["QR display TV", Tv, "#3B82F6"], codici: ["QR PDF codici", FileText, "#8B5CF6"],
  ricevuta: ["QR ricevuta", Receipt, "#EC4899"], concorsi: ["Pagina concorsi", Globe, "#10B981"], totem_pannello: ["Pannello totem", QrCode, "#FBBF24"],
  punto_vendita: ["Punto vendita", Store, "#14B8A6"], link: ["Link diretto", Link2, "#94a3b8"], page: ["Link diretto", Link2, "#94a3b8"],
};

function Counter({ value }) {
  const [v, setV] = useState(0);
  useEffect(() => {
    const c = animate(v, value, { duration: 1.2, ease: "easeOut", onUpdate: (x) => setV(Math.round(x)) });
    return () => c.stop();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);
  return <>{v}</>;
}

export default function RulesSourceRace({ contestId }) {
  const [rows, setRows] = useState([]);
  useEffect(() => {
    const load = () => api.rulesSources(contestId).then(setRows).catch(() => {});
    load();
    const t = setInterval(load, 20000);
    return () => clearInterval(t);
  }, [contestId]);
  if (!rows.length) return null;
  const total = rows.reduce((a, r) => a + r.views, 0) || 1;
  const top = rows.slice(0, 5);
  return (
    <div className="w-full max-w-[70vmin] rounded-[2vmin] bg-black/45 backdrop-blur-md border border-white/15 p-[2.5vmin] text-left mt-[2vmin]" data-testid="display-rules-race">
      <div className="flex items-center gap-[1vmin] mb-[1.5vmin]">
        <QrCode className="h-[2.8vmin] w-[2.8vmin] text-amber-400" />
        <h2 className="font-display font-bold text-[2.8vmin] leading-none">Da dove leggono il regolamento</h2>
        <span className="ml-auto text-[1.8vmin] text-white/60">{total} letture</span>
      </div>
      <div className="space-y-[1.2vmin]">
        {top.map((r, i) => {
          const [label, Icon, color] = META[r.source] || [r.source, Link2, "#94a3b8"];
          const pct = Math.round((r.views / total) * 100);
          return (
            <motion.div layout key={r.source} className="relative overflow-hidden rounded-[1.2vmin] bg-white/10" data-testid={`rules-race-${r.source}`} transition={ROW_TRANSITION}>
              <motion.div className="absolute inset-y-0 left-0 rounded-[1.2vmin]" style={{ background: color, opacity: 0.4 }} initial={BAR_INITIAL} animate={{ width: `${pct}%` }} transition={BAR_TRANSITION} />
              <div className="relative flex items-center gap-[1.5vmin] px-[1.5vmin] py-[1.1vmin]">
                <span className="font-display font-black text-[2.4vmin] text-white/50 w-[3vmin]">{i + 1}</span>
                <span className="grid place-items-center h-[3.2vmin] w-[3.2vmin] rounded-full" style={{ background: color }}><Icon className="h-[1.9vmin] w-[1.9vmin] text-slate-900" /></span>
                <span className="font-semibold text-[2.1vmin] flex-1">{label}</span>
                <span className="text-[1.7vmin] text-white/70">{r.unique} lettori</span>
                <span className="font-display font-black text-[2.6vmin] w-[8vmin] text-right"><Counter value={r.views} /></span>
                <span className="text-[1.9vmin] text-white/80 w-[6vmin] text-right">{pct}%</span>
              </div>
            </motion.div>
          );
        })}
      </div>
    </div>
  );
}
